import { render } from "./NullComponent.vue?vue&type=template&id=fe3ea37c&scoped=true"
import script from "./NullComponent.vue?vue&type=script&lang=js"
export * from "./NullComponent.vue?vue&type=script&lang=js"

import "./NullComponent.vue?vue&type=style&index=0&id=fe3ea37c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\niso\\Documents\\repos\\storyworld-everhouse-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe3ea37c"]])

export default __exports__